const ru = {
  mainTitle: 'ПРАКТИЧЕСКИЙ ПРОТОКОЛ ДОЛГОЛЕТИЯ',
  habitTooltipTitle: 'Зачем это делать?',
  foodScienceFactsTitle: 'Научные факты повлиявшие на меня больше всего',
  whatNotToEatTitle: 'Что не есть',
  whatToEatTitle: 'Что есть',
  damageIndexTitle: 'Индекс вреда',
  examplesTitle: 'Примеры',
  genericRulesTitle: 'Общие правила',
  healthChoicesTitle: 'Полезные продукты в Армении',
  hacksTitle: 'Лайфхаки',
  tooltipSubText: 'Последствия потребления',
  viewSleepChart: 'Показать чарт структуры сна',
  viewSupplementsChart: 'Показать чарт структуры добавок',
  environmentHeadlines: {
    home: 'Дом',
    principles: 'Принципы',
    dataTracking: 'Сбор данных',
  },
  supplementsHeadlines: {
    foundational: 'Основные',
    longevity: 'Долголетие и здоровье клеток',
    performance: 'Производительность и восстановление',
    situational: 'Ситуативно',
  },
  supplementsTableHeadlines: [
    'Область',
    'Без добавок',
    'С добавками (Общие)',
    'Подбор и оптимизация (На основе анализа крови)',
  ],
  whatTOEatOrAvoidContent: {
    damageIndexTxt: 'Индекс вреда: ',
    yourDietTxt: 'Ваша диета',
  },
  yourDietContent: {
    brainPreservation: 'Здоровье мозга',
    yearsGained: 'К продолжительности жизни',
    biologicalAge: 'Биологический возраст: ',
    skinAge: 'Возраст кожи: ',
    jointAge: 'Возраст связок: ',
    metabolicAge: 'Метаболический возраст: ',
    yearSingular: 'год',
    yearFew: 'года',
    yearMany: 'лет',
  },
  sleepTableTitles: [
    'Ключевые правила мозга',
    'Нет структуры',
    'Моя структура',
    'Полностью оптимизировано',
  ],
  sleepHeadlines: {
    keyBrainRules: 'Ключевые правила мозга',
    usedDevices: 'Использованные девайсы',
  },
  workoutHeadlines: {
    mandatoryWorkouts: 'Обязательные тренировки',
    optionalWorkouts: 'Опциональные тренировки',
    workoutSupplements: 'Тренировочные добавки',
  },
  totalWeeklyActivity: {
    title: 'Общая еженедельная активность',
    minutes: 'минуты',
    min: 'мин',
    week: 'неделя',
    years: 'лет',
    minAndSessions: 'Минуты / Сессия',
    sessionsAndWeek: 'Сессии / Неделя',
    earlyDyingRisk: 'Риск ранней смерти',
    brainAgeTitle: 'Возраст мозга с разными уровнями активности',
    brainAgeSubTitle: 'Выберите базовый возраст чтобы увидеть разницу',
    dementiaRisk:
      'Оценочный риск нарушения когнитивных функций/развития деменции',
    agingTrajectory: 'Траектория старения мозга',
    brainIfSedentary: 'Возраст мозга',
    brainIfSedentarySubText: '(сидячий образ жизни)',
    brainIfActive: 'Возраст мозга',
    brainIfActiveSubText: ' (активный образ жизни)',
    strengthTitle: 'Сила и Необходимое время тренировки',
    strengthSubTitle: 'Ваш уровень физ. силы',
    activityLevels: [
      {
        level: 'Новичок',
        minutesPerSession: 65,
        totalMinutesPerWeek: 240,
      },
      {
        level: 'База',
        minutesPerSession: 60,
        totalMinutesPerWeek: 180,
      },
      {
        level: 'Сильный',
        minutesPerSession: 50,
        totalMinutesPerWeek: 150,
      },
      {
        level: 'Очень сильный',
        minutesPerSession: 40,
        totalMinutesPerWeek: 120,
      },
      {
        level: 'Атлет',
        minutesPerSession: 30,
        totalMinutesPerWeek: 90,
      },
    ],
    summaryContent: [
      {
        minutes: 0,
        riskOfDyingEarly: 'Высший риск (100% база)',
        cognitiveDecline: 'База (0%)',
        brainAgingActive: 'Нет фитнес защиты',
        brainAgingSedentary: ' Ускоренное старение',
      },
      {
        minutes: 75,
        riskOfDyingEarly: '90% риск ранней смерти',
        cognitiveDecline: 'на 5-10% меньше',
        brainAgingActive: 'Слегка моложе',
        brainAgingSedentary: 'Слегка старше',
      },
      {
        minutes: 150,
        riskOfDyingEarly: '80% риск ранней смерти',
        cognitiveDecline: 'на 15–20% меньше',
        brainAgingActive: 'Значительно моложе',
        brainAgingSedentary: 'Заметно старше',
      },
      {
        minutes: 225,
        riskOfDyingEarly: '72% риск ранней смерти',
        cognitiveDecline: 'на 20–30% меньше',
        brainAgingActive: 'Стабильно гораздо моложе',
        brainAgingSedentary: 'Значительно старше, ускоренное старение',
      },
      {
        minutes: 300,
        riskOfDyingEarly: '65% риск ранней смерти',
        cognitiveDecline: 'на 25–35% меньше',
        brainAgingActive: 'Оптимизированно',
        brainAgingSedentary: 'Худший сценарий старения мозга',
      },
    ],
  },
  navigationItems: {
    aboutProject: 'О проекте',
    habits: 'Привычки',
    environment: 'Окружающая среда',
    results: 'Результаты',
    aiAssistant: 'ИИ Ассистент',
  },
  subNavigationItems: {
    lifestyle: 'Лайфстайл',
    study: 'Обучение',
    diet: 'Питание',
    workout: 'Тренировка',
    sleep: 'Сон',
    supplements: 'Добавки',
  },
  nextBtn: 'Далее: ',
  contentsTxt: 'Содержание',
};

export default ru;
